<template>
    <div>
        <general-table
            :columns="columns"
            :url="route('contacts.table')"
            :filters="filters"
            :clickableRow="clickableRow"
            :selectActions="selectActions"
            selectable
            itemNoun="contact"
        />
        
    </div>
</template>

<script>
import JetDropdown from "../Jetstream/Dropdown";
import JetDropdownLink from "../Jetstream/DropdownLink";
import JetDialogModal from "../Jetstream/DialogModal";
import JetSecondaryButton from "../Jetstream/SecondaryButton";
import JetNavLink from "../Jetstream/NavLink";
import Button from "../Jetstream/Button";
import JetDangerButton from "../Jetstream/DangerButton";
import ContactTableButton from "../components/ContactTableButton";
import ContactTableName from "@/components/ContactTableName";
import ContactTableList from "@/components/ContactTableList";
import ContactTableStatus from "@/components/ContactTableStatus";
import GeneralTable from "@/components/GeneralTable/GeneralTable";

import contactTableActionAddToList from "@/components/ContactTableActionAddToList";
import contactTableActionAssignTo from "@/components/ContactTableActionAssignTo";
import contactTableActionDelete from "@/components/ContactTableActionDelete";

import {mapWritableState} from 'pinia';
import contactStore from '../Stores/contacts.js';
import {markRaw} from 'vue';
export default {
    components: {
        GeneralTable,
    },
    data() {
        return {
            clickableRow: {
                route: 'contacts.view',
                id: 'id',
            },
            columns: [
                {
                    label: "Name",
                    name: "name",
                    sortable: true,
                    component: markRaw(ContactTableName),
                    width: '1fr',
                },
                {
                    label: "Phone Number",
                    name: "phone_number",
                    sortable: true,
                    width: '175px',
                },
                {
                    label: "Status",
                    name: "status",
                    sortable: false,
                    component: markRaw(ContactTableStatus),
                    width: '170px',
                },
                {
                    label: "Lists",
                    name: "lists",
                    sortable: false,
                    component: markRaw(ContactTableList),
                    width: '1fr',
                },
                {
                    label: "Assigned to",
                    name: "assigned_to_user",
                    sortable: true,
                    width: '150px',
                },

                {
                    label: "",
                    name: "View",
                    sortable: false,
                    width: '60px',
                    component: markRaw(ContactTableButton),
                }
            ],
            filters: [
                {
                    label: "Contact",
                    value: "contact",
                    type: "contact",
                    multiple: false, // because contact component already supports multiple
                },
                {
                    label: "List",
                    value: "list",
                    type: "list",
                    multiple: true,
                },
                {
                    label: "Status",
                    value: "status",
                    type: "select",
                    multiple: true,
                    options: [
                        { label: "Good Contact", value: "good_contact" },
                        { label: "Opted Out", value: "opt_out" },
                    ],
                },
            ],
            selectActions: [
                {
                    label: "Add to List",
                    value: "add_to_list",
                    component: markRaw(contactTableActionAddToList),
                },
                {
                    label: "Assign to",
                    value: "assign_to",
                    component: markRaw(contactTableActionAssignTo),
                },
                {
                    label: "Delete",
                    value: "delete",
                    component: markRaw(contactTableActionDelete),
                }
            ],
            showDeletionModal: false,
            showEditModal: false,
            contactEditDetails: {
                first_name: null,
                last_name: null,
                phone_number: null,
                id: null
            },
        };
    },
    computed: {
        ...mapWritableState(contactStore, ['contactsImported']),
    },
    methods: {
    },
    watch: {
    }
};
</script>
